import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Box,
  Card,
  CardContent,
  Divider,
  Modal,
  Typography
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import { cash } from 'variables/paymentMethods';

const DailyAccounts = (props) => {

  const columns = [
    { field: 'displayId', headerName: 'ID', flex: 1, sortable: false },
    { field: 'total', headerName: 'Total Amount', flex: 1, sortable: false }
  ];

  const [cashInTableData, setCashInTableData] = useState([]);
  const [CashOutTableData, setCashOutTableData] = useState([]);

  useEffect(() => {
    let cashInBuffer = [];
    let cashOutBuffer = [];
    
    const todaysDate = moment();

    //CASH IN
    //Sales Orders
    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      if(todaysDate.isSame(props.salesOrders[i].createdAt, 'day') && props.salesOrders[i].paymentMethod === cash) {
        const salesOrder = props.salesOrders[i];
        cashInBuffer.push({
          id: salesOrder.id,
          displayId: salesOrder.displayId,
          total: salesOrder.total
        });
      }
    }

    //CASH IN
    //Return Orders
    for ( let i = 0; i < props.returnOrders.length; i++ ) {
      if (todaysDate.isSame(props.returnOrders[i].createdAt, 'day') && props.returnOrders[i].paymentByCash) {
        const returnOrder = props.returnOrders[i];
        cashInBuffer.push({
          id: returnOrder.id,
          displayId: returnOrder.displayId,
          total: returnOrder.total
        });
      }
    }

    //CASH OUT
    //Purchase Orders
    for ( let i = 0; i < props.purchaseOrders.length; i++ ) {
      const currPurchaseOrder = props.purchaseOrders[i];
      for ( let j = 0; j < currPurchaseOrder.payments.length; j++ ) {
        if(todaysDate.isSame(currPurchaseOrder.payments[j].createdAt, 'day') && currPurchaseOrder.payments[j].paymentByCash) {
          const payment = currPurchaseOrder.payments[j];
          cashOutBuffer.push({
            id: payment.displayId,
            displayId: payment.displayId,
            total: payment.amount
          });
        }
      }
    }

    //CASH OUT
    //Expenses
    for ( let i = 0; i < props.expenses.length; i++ ) {
      if (todaysDate.isSame(props.expenses[i].createdAt, 'day')) {
        const expense = props.expenses[i];
        cashOutBuffer.push({
          id: expense.displayId,
          displayId: expense.displayId,
          total: expense.total
        });
      }
    }
    
    setCashInTableData(cashInBuffer);
    setCashOutTableData(cashOutBuffer);
    
  }, [props.salesOrders, props.expenses, props.purchaseOrders, props.returnOrders, props.month]);

  return (
    <Modal open={props.open}>
      <Card>
        <CardContent>
          <Box>
            <Box>
              <Typography
                color="textPrimary"
                variant="h5"
              >
                Today's Date : {moment().format("DD/MM/YYYY")}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                columnGap: 40,
                marginBottom: '1%'
              }}
            >
              <Typography
                color="textPrimary"
                variant="h6"
              >
                CASH IN : {cashInTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
              </Typography>
              <Typography
                color="textPrimary"
                variant="h6"
              >
                CASH OUT : {CashOutTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
              </Typography>
              <Typography
                color="textPrimary"
                variant="h6"
              >
                PROFIT : {cashInTableData.reduce((prev, curr) => prev + curr.total, 0) - CashOutTableData.reduce((prev, curr) => prev + curr.total, 0)} AED
              </Typography>
            </Box>
            <Divider/>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1%'
              }}
            >
              <Box
                sx={{
                  height: 474,
                  width: '100%'
                }}
              >
                {/* CASH IN */}
                <Typography
                  align="center"
                  color="textPrimary"
                  variant="h5"
                >
                  CASH IN
                </Typography>
                <DataGrid
                  rows={cashInTableData}
                  columns={columns}
                  disableSelectionOnClick
                  disableColumnMenu
                  hideFooter
                  localeText={{
                    noRowsLabel: 'No Transactions'
                  }}
                />
              </Box>
              <Box
                sx={{
                  height: 474,
                  width: '100%'
                }}
              >
                {/* CASH OUT */}
                <Typography
                  align="center"
                  color="textPrimary"
                  variant="h5"
                >
                  CASH OUT
                </Typography>
                <DataGrid
                  rows={CashOutTableData}
                  columns={columns}
                  disableSelectionOnClick
                  disableColumnMenu
                  hideFooter
                  localeText={{
                    noRowsLabel: 'No Transactions'
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '2%'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={props.closeModal}
              >
                Close
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default DailyAccounts;